// removed by extract-text-webpack-plugin
module.exports = {"loginForm":"ResetProfileForm__loginForm__3iX60","alertsMb":"ResetProfileForm__alertsMb__15AIN","submitButton":"ResetProfileForm__submitButton__3wYO8","paragraph":"ResetProfileForm__paragraph__141JQ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ResetProfileForm/ResetProfileForm.css
// module id = 571
// module chunks = 0